import * as z from "zod";
import { V2AdminProductIdSchema } from "./admin-products";

export const archiveOnboardingV2Product = {
  name: "archiveOnboardingV2Product" as const,
  input: z.object({
    teamId: z.string().min(1),
    productId: V2AdminProductIdSchema,
  }),
  output: z.object({ success: z.boolean() }),
};

export type ArchiveOnboardingV2ProductInput = z.infer<
  typeof archiveOnboardingV2Product.input
>;
export type ArchiveOnboardingV2ProductOutput = z.infer<
  typeof archiveOnboardingV2Product.output
>;
